<div class="cdr-processing-container">
  <div class="header">
    <h1>Procesamiento de CDR</h1>
  </div>

  <div class="content">
    <form class="upload-form" enctype="multipart/form-data">
      <div class="form-row">
        <div class="form-block">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Tipo</mat-label>
            <mat-select [(value)]="selectedType">
              <mat-option *ngFor="let option of typeOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-block">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cliente</mat-label>
            <mat-select [(value)]="selectedClient" (selectionChange)="onClientChange()">
              <mat-option *ngFor="let option of clientOptions" [value]="option.code">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-block">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Precio por SMS</mat-label>
            <input matInput type="number" [(ngModel)]="pricePerSms" [ngModelOptions]="{standalone: true}" step="0.00001" min="0" />
          </mat-form-field>
        </div>
      </div>

      <div class="form-block">
        <label for="cdr">Ficheros CDR</label>
        <input id="cdr" type="file" (change)="onFileChange($event)" accept=".csv,.txt,.xlsx,.xls" multiple />
      </div>

      <div class="form-block" *ngIf="outputFilename">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nombre fichero salida</mat-label>
          <input matInput [(ngModel)]="outputFilename" [ngModelOptions]="{standalone: true}" />
          <span matSuffix>.xlsx</span>
        </mat-form-field>
      </div>

      <div class="button-container">
        <button mat-raised-button
                color="primary"
                [disabled]="isLoading || cdrFiles.length === 0"
                class="process-button"
                (click)="processFile()"
        >
          <span class="button-content">
            <mat-spinner
              *ngIf="isLoading"
              diameter="16"
              strokeWidth="3"
              mode="indeterminate"
              color="accent"
              class="spinner-inline"
            />

            <span class="text-label">
              {{ isLoading ? 'Procesando...' : 'Procesar CDR' }}
            </span>
          </span>
        </button>
      </div>

    </form>

    <div class="log-block" *ngIf="logMessages.length > 0">
      <label>Log de procesamiento</label>
      <textarea class="log-textarea" readonly [value]="logText"></textarea>
    </div>
  </div>
</div>
